<template>
    <div>
        <MenuFacade :pages="contents.pages"></MenuFacade>
        <Header v-if="shouldShow" :pages="contents.pages" :route-data="header"></Header>
        <router-view :contents="contents"></router-view>
        <div class="w-full h-8 bg-black">
            <h5 style="color: rgba(203, 213, 224, 0.46);" class="text-center py-2">Alle rechten voorbehouden &copy; E. Budding Vloerverwarming</h5>
        </div>
    </div>
</template>

<script>
    import './assets/css/tailwind.css'
    import './assets/css/main.css'
    import api from 'axios'
    import Header from "./components/Misc/Header"
    import MenuFacade from "./components/Menu/MenuFacade"

    export default {
        name: 'app',
        components: {MenuFacade, Header},
        data() {
            return {
                contents: [],
                header: {},
                shouldShow: true,
            }
        },
        updated() {
            this.header = this.contents.pages[this.$route.name];
            this.shouldShow = this.$route.name !== 'http404' || this.$route.name !== 'about';
            this.getImages();
        },
        created() {
            let self = this;
            api.get('https://api.vloerverwarminginfrezen.info/api/content/get')
                .then(res => {
                    self.contents = res.data;
                    document.title = self.contents.title;
                })

            //api.get('/content/get')
           //    .then(res => {
           //        self.contents = res.data;
           //        document.title = self.contents.title;
           //    })
        },
        methods: {
            getImages() {
                return this.contents.display_images.image_paths;
            },
            refreshData() {
                api.get('https://api.vloerverwarminginfrezen.info/api/content/get')
                    .then(res => res.data)
            }
        }
    }
</script>

<style>
    * {
        margin: 0;
        padding: 0;
        list-style: none;
        text-decoration: unset;
    }
</style>
